var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientProfileListing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "patient-profile-listing",
    transform: "translate(-360 -299)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(360 299)",
    fill: "#ebf7fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "patients",
    transform: "translate(369.109 308.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M0,0H22V22H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M4,20.249a7.333,7.333,0,0,1,14.666,0H16.833a5.5,5.5,0,0,0-11,0ZM11.333,12a5.5,5.5,0,1,1,5.5-5.5A5.5,5.5,0,0,1,11.333,12Zm0-1.833A3.667,3.667,0,1,0,7.667,6.5,3.666,3.666,0,0,0,11.333,10.166Z",
    transform: "translate(-0.333 -0.083)",
    fill: "#09c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientProfileListing);
export default __webpack_public_path__ + "static/media/patient-profile-listing.215793e9662ff481d9fc20ec01fef507.svg";
export { ForwardRef as ReactComponent };